export default "<div style=\"text-align:center;margin-top: 3%\">\r\n  <h1>Page not found</h1>\r\n</div>\r\n";